export default "__VITE_ASSET__DHWXKLSP__"